import { render, staticRenderFns } from "./FormBox.vue?vue&type=template&id=c7b7c570&"
import script from "./FormBox.vue?vue&type=script&lang=js&"
export * from "./FormBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports